


















import { randomString } from 'frontend/utils/formatting';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class MenuIcon extends Vue {
  private get clipId(): string {
    return randomString('menu');
  }
}
